import { render, staticRenderFns } from "./AttachmentImage.vue?vue&type=template&id=e00e615c&scoped=true"
import script from "./AttachmentImage.vue?vue&type=script&lang=js"
export * from "./AttachmentImage.vue?vue&type=script&lang=js"
import style0 from "./AttachmentImage.vue?vue&type=style&index=0&id=e00e615c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e00e615c",
  null
  
)

export default component.exports